module.exports = "<div class=\"clickable\" (click)=\"onClick($event)\">\n  <ng-content #card></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/common/clickable-wrapper-container/clickable-wrapper-container.component.html
// module id = 927
// module chunks = 0